<template>
  <CRow>
  <Loading v-if="loading" />
    <CCol col="12">
        <CCard>
            <CCardHeader>
                <h4>Zoek gebruiker sessie</h4>
            </CCardHeader>
            <CCardBody>
                <CInput v-model="search" :disabled="loading" v-on:keypress.enter="searchSession" placeholder="Search podcast shows" class="mt-2 mb-4 clear-icon">
                     <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
                    <template v-if="search" #append-content>
                        <CButton @click="searchSession"> Zoek user sessie <CIcon name="cil-magnifying-glass"/></CButton>
                    </template>
                </CInput>

                <CDataTable
                    hover
                    striped
                    :items="user_sessions"
                    :fields="fields"
                    v-if="!no_matching_users && user_sessions.length > 0">
                    <template #auth_date="{item}">
                        <td>
                            {{ item.session_obj.data.CAS_ATTRIBUTES.authenticationDate }}
                        </td>
                    </template>
                    <template #paid="{item}">
                        <td>
                            {{ !!item.session_obj.data.CAS_ATTRIBUTES.rights }}
                        </td>
                    </template>
                </CDataTable>
                <div v-else-if="no_matching_users">
                    <h5>Geen user sessies gevonden met dat email</h5>
                </div>
            </CCardBody>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Loading from "@/components/Loading";

export default {
    name: "UserSessions",
    components: {
        Loading,
    },
    data() {
        return {
            fields: [
                { key: 'session_token', sorter: true, label: 'Token' },
                { key: 'auth_date', label: 'Authenticatie datum'},
                { key: 'paid', label: 'Betaald?'}
            ],
            search: '',
            user_sessions: [],
            no_matching_users: false,
            loading: false,
        }
    },
    methods: {
        searchSession() {
            this.loading = true
            this.$api.get(`session_token/${this.search}`).then(response => {
                this.no_matching_users = false
                this.user_sessions = response.data
                this.loading = false
            }).catch(() => {
                this.no_matching_users = true
                this.user_sessions = []
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
    .clear-icon .btn {
      height: 24px;
      padding: 0;
      margin: -4px;
    }

    pre {
        white-space: pre-wrap;
    }
</style>